export default __webpack_public_path__ + "static/media/feature-project-mgt-2.e544fb12.png";